const INVALID_CREDENTIALS_PATTERN = /invalid email or password|invalid credentials/i;
const EMAIL_ALREADY_EXISTS_PATTERN = /already exists/i;

export const getApiErrorMessage = (
  error: any,
  fallbackKey: string,
  t: (k: string) => string
): string => {
  if (!error?.response) {
    return t('networkError');
  }

  const backendMessage: string =
    error.response?.data?.message || error.response?.data?.error || '';

  if (INVALID_CREDENTIALS_PATTERN.test(backendMessage)) {
    return t('invalidCredentials');
  }

  if (EMAIL_ALREADY_EXISTS_PATTERN.test(backendMessage)) {
    return t('emailAlreadyExists');
  }

  return t(fallbackKey);
};
